import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ActionModel} from '../../models/action';
import {ComponentModel} from '../../models/component';
import {ActionService} from '../../services/action.service';
import {ComponentService} from '../../services/component.service';
import {Privilege} from '../../models/privilege';
import {PrivilegeService} from '../../services/privilege.service';
import {UserProfile} from '../../models/user-profile';

@Component({
  selector: 'app-checkbox-table',
  templateUrl: './checkbox-table.component.html',
  styleUrls: ['./checkbox-table.component.scss']
})
export class CheckboxTableComponent {

  loading: number;
  actions: ActionModel[];
  components: ComponentModel[];
  settablePrivileges: Privilege[];

  @Input() profiles: UserProfile[];
  @Input() privileges: Privilege[];
  @Input() editMode: boolean;

  @Output() userPrivilegesUpdated = new EventEmitter<Privilege[]>();

  /**
   * Set variables and load data from the database
   * @param {ActionService} actionService
   * @param {ComponentService} componentService
   * @param {PrivilegeService} privilegeService
   */
  constructor(private actionService: ActionService,
              private componentService: ComponentService,
              private privilegeService: PrivilegeService) {

    /**
     * Set number of resources to load
     * @type {number}
     */
    this.loading = 3;

    /**
     * Load the actions
     */
    this.actionService.getAllActions().subscribe((actions) => {
      this.actions = actions;
      this.loading--;
    });

    /**
     * Load the components
     */
    this.componentService.getAllComponents().subscribe((components) => {
      this.components = components;
      this.loading--;
    });

    /**
     * Load the privileges
     */
    this.privilegeService.getSettablePrivileges().subscribe((privileges) => {
      this.settablePrivileges = privileges;
      this.updatePrivileges();
      this.loading--;
    });

  }

  /**
   * Define if the checkbox can be set
   * @param {ActionModel} action
   * @param {ComponentModel} component
   * @returns {boolean}
   */
  isSettable(action: ActionModel, component: ComponentModel): boolean {
    return this.settablePrivileges.find((privilege) => privilege.action === action.id && privilege.component === component.id) !== null;
  }

  /**
   * Get privilege according to the action id and the component id
   * @param {ActionModel} action
   * @param {ComponentModel} component
   * @returns {Privilege | undefined}
   */
  getPrivilege(action: ActionModel, component: ComponentModel) {
    return this.settablePrivileges.find((privilege) => privilege.action === action.id && privilege.component === component.id);
  }

  /**
   * Update privileges with the profiles and privileges resources
   */
  updatePrivileges() {
    if (this.settablePrivileges) {
      this.settablePrivileges.map(privilege => privilege.checkedByProfiles(this.profiles));
      this.settablePrivileges.map(privilege => privilege.checkedByInputPrivileges(this.privileges));
      this.settablePrivileges.map(privilege => privilege.checkedByLogicPrivileges(this.privileges, this.settablePrivileges));
    }
  }

  /**
   * Remap settable privileges when a change is emit from the checkboxes
   */
  checkboxChange() {
    this.userPrivilegesUpdated.emit();
    this.settablePrivileges.map(privilege => {
      this.settablePrivileges.find(p => p.component === privilege.component && p.action === 1).checkedByLogic = false;
      if (privilege.action === 2 && privilege.checked && !privilege.checkedByExtends) {
        this.settablePrivileges.find(p => p.component === privilege.component && p.action === 1).checkedByLogic = true;
        this.settablePrivileges.find(p => p.component === privilege.component && p.action === 1).checked = true;
      }
      if (privilege.action === 2 && !privilege.checked && !privilege.checkedByExtends) {
        if (this.settablePrivileges.find(p => p.component === privilege.component && p.action === 1).checkedByLogic) {
          this.settablePrivileges.find(p => p.component === privilege.component && p.action === 1).checkedByLogic = false;
          this.settablePrivileges.find(p => p.component === privilege.component && p.action === 1).checked = true;
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/checkbox-table/checkbox-table.component.ts